import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import _classCallCheck from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/var/www/lime25/limesurvey/assets/packages/emailtemplates/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import { insertImage, isImageAllowed } from "./utils";
/**
 * @module image/image/imageinsertcommand
 */

/**
 * Insert image command.
 *
 * The command is registered by the {@link module:image/image/imageediting~ImageEditing} plugin as `'imageInsert'`.
 *
 * In order to insert an image at the current selection position
 * (according to the {@link module:widget/utils~findOptimalInsertionPosition} algorithm),
 * execute the command and specify the image source:
 *
 *		editor.execute( 'imageInsert', { source: 'http://url.to.the/image' } );
 *
 * It is also possible to insert multiple images at once:
 *
 *		editor.execute( 'imageInsert', {
 *			source:  [
 *				'path/to/image.jpg',
 *				'path/to/other-image.jpg'
 *			]
 *		} );
 *
 * @extends module:core/command~Command
 */

var ImageInsertCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(ImageInsertCommand, _Command);

  function ImageInsertCommand() {
    _classCallCheck(this, ImageInsertCommand);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImageInsertCommand).apply(this, arguments));
  }

  _createClass(ImageInsertCommand, [{
    key: "refresh",

    /**
     * @inheritDoc
     */
    value: function refresh() {
      this.isEnabled = isImageAllowed(this.editor.model);
    }
    /**
     * Executes the command.
     *
     * @fires execute
     * @param {Object} options Options for the executed command.
     * @param {String|Array.<String>} options.source The image source or an array of image sources to insert.
     */

  }, {
    key: "execute",
    value: function execute(options) {
      var model = this.editor.model;
      model.change(function (writer) {
        var sources = Array.isArray(options.source) ? options.source : [options.source];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var src = _step.value;
            insertImage(writer, model, {
              src: src
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  }]);

  return ImageInsertCommand;
}(Command);

export { ImageInsertCommand as default };